import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetMarkAsViewed, GetNotificationCount, GetNotificationList } from "../services";
import { toggleNotification, updateNotificationList } from "./notificationSlice";

// Async thunk to fetch notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (_,{rejectWithValue}) => {
    try {
      let response = await GetNotificationList();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
    
  }
);

export const fetchNotificationsCount = createAsyncThunk(
  "notifications/fetchNotificationsCount",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await GetNotificationCount();
      if (response.data.count > 0) dispatch(toggleNotification(true))
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const NotificationMarkAsViewed = createAsyncThunk(
  "notifications/NotificationMarkAsViewed",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    try {
      const { notificationData } = getState();
      const { notifications } = notificationData;
      const response = await GetMarkAsViewed(payload);

      let updatedList = notifications.filter((item) => payload != item.id)
      if (response.status == 200 || response.status == 201) {
        if (updatedList.length == 0) {
          dispatch(toggleNotification(false));
        } else {
          dispatch(updateNotificationList(updatedList));
        }
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)